import { Fragment, type FC } from 'react';
import { describeKeys, type KeyboardShortcut } from './keyboard-shortcut';
import { Kbd, KbdGroup } from './kbd';

interface KeyboardShortcutKeysProps {
  keys: KeyboardShortcut['keys'];
}

/** The chips for a shortcut: keys pressed together, alternatives joined by "or". */
export const KeyboardShortcutKeys: FC<KeyboardShortcutKeysProps> = ({ keys }) => (
  <span className="flex shrink-0 flex-wrap items-center gap-1.5">
    {keys.map((combo, index) => (
      <Fragment key={combo.join('+')}>
        {index > 0 ? (
          <span className="text-caption text-muted-foreground">or</span>
        ) : null}
        <KbdGroup>
          {/* kbd takes no aria-label; say the keys, show the glyphs. */}
          <span className="sr-only">{describeKeys(combo)}</span>
          {/* By position: a double press (⌫ ⌫) repeats the same key. */}
          {combo.map((key, at) => (
            <Kbd key={`${key}-${at}`} aria-hidden="true">
              {key}
            </Kbd>
          ))}
        </KbdGroup>
      </Fragment>
    ))}
  </span>
);
